
<app-chacras-map-detail (onClose)="onClose()" [dataInput]="data.item" *ngIf="isChacraItem()"
></app-chacras-map-detail>
